import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {runInAction } from "mobx"
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import type {NewSearchWidgetState} from "../models/new-search-widget.state";

export class NewSearchWidgetSearchResetHandler extends ActionHandler {
  state: NewSearchWidgetState;
  type= NEW_SEARCH_WIDGET.ACTION_TYPES.RESET.onSearchReset;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    runInAction(() => {

      if(params?.fullReset) {
        this.state.competitionsSearchListModel = null;
        this.state.competitorsSearchListModel = null;
        this.state.athletesSearchListModel = null;
      } else if(this.state.hasResults) {
        this.state.competitionsSearchListModel.entities = [];
        this.state.competitorsSearchListModel.entities = [];
        this.state.athletesSearchListModel.entities = [];
      }
    })
  }
}
